import { cn } from '@/utils/cn'
import { ClassValue } from 'clsx'
import React from 'react'

export default function Title({children, className, color = "dark"}: {children: React.ReactNode, className?: ClassValue, color?: "dark" | "light"}) {
  return (
    <h1 className={cn("text-5xl lg:text-6xl font-medium", color === "dark" ? "text-zinc-800" : "text-white", className || "")}>
        {children}
    </h1>
  )
}